import { graphql } from "@/gql";

export const callbackLeadCountsQuery = graphql(`
  query CallbackLeadCounts {
    callbackLeadCounts {
      pending
      pendingIncompleteBooking
      pendingSupplierCancellation
      snoozed
    }
  }
`);
